// ----------      START   IMPORT  BLOCK        ----------
import React from 'react';
import BaseLayout from '../../Widgets/General/LandingPage/BaseLayout/BaseLayout';
import { useLanguage } from '../../../API/Context/LanguageContext';
import VocabLandingPage from '../../../ConfigFiles/multilingual/VocabLandingPage';
import { LandingPageSearchBar } from './LandingPageSearchBar';
import './LandingPage.css';
// ----------      END   IMPORT  BLOCK        ----------

function LandingPage() {
  const { lan } = useLanguage();

  return (
    <BaseLayout>
      <div style={{ minHeight: '100vh' }} className="landing-content">
        <h1>{VocabLandingPage.brand[0]}</h1>
        <h3 className="motto">{VocabLandingPage.motto[lan]}</h3>

        <div className="search-section">
          <LandingPageSearchBar />
        </div>
      </div>
    </BaseLayout>
  );
}

export default LandingPage;